import cta from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  eyebrow: 'Netherlands',
  heading: 'Hallo uit Amsterdam.',
  heading_size: 'h4',
  copy:
    '<p><a href="#">+44 (0) 207 262 0011</a><br />' +
    '<a href="#">email@email.com</a><br />' +
    '<a href="#" target="_blank">Map</a></p>',
  cta: [
    {
      ...cta,
      copy: 'Visit website',
      href: {
        url: '/',
        cached_url: '/',
      },
      type: 'secondary',
    },
  ],
  component: 'm-card-office',
}
